import { useRef, useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../config";
import Swal from 'sweetalert2'

const UploadFile = (props) => {
  const { setUploadedFileData } = props;
  const [file, setFile] = useState(null);
  const [isDiarised, setDiarised] = useState(true);
  const [loading, setLoading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("");
  const [errorPageData, setErrorPageData] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (!file) {
      alert("Please select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("diarise", isDiarised);

    try {
      setLoading(true);
      setUploadStatus("Uploading...");
      const response = await axios.post(
        `${REACT_APP_API_URL}/api2/upload`,
        formData,
        {
          headers: new Headers({
            "ngrok-skip-browser-warning": "69420",
          }),
        }
      );
      setUploadedFileData(response.data);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setUploadStatus("File uploaded successfully!");
    } catch (error) {
      setUploadStatus("Failed to upload file");
      if (error.status >= 400 && error.status <= 500) {
        setErrorPageData(
          error?.response?.data?.error || "somethign went wrong!"
        );
      }
      const errorMessage = `${error?.response?.data?.error}`;
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.response?.data?.error
        ? errorMessage
        : `status code: ${error?.response?.status ?  error?.response?.status : 'server down/'} \n something went wrong`,
      });
    } finally {
      setLoading(false);
      setFile(null);
      setTimeout(() => {
        setUploadStatus(null);
      }, 1000 * 10);
    }
  };

  return (
    <div>
      <p className="upload-new-file">Upload A New File</p>
      {loading ? (
        <>
          <img src="/upload.gif" alt="uploading..." />
        </>
      ) : (
        <div className="input-container">
          <div>
            <label htmlFor="file-upload" className="custom-file-upload">
              {file?.name ?? "Select File"}
            </label>
            <input
              type="file"
              name="file"
              id="file-upload"
              accept="audio/*"
              onChange={handleFileChange}
              ref={fileInputRef}
            />
          </div>
          <div>
            <label htmlFor="diarised">Diarized</label>
            <input
              type="checkbox"
              id="diarised"
              name="diarised"
              checked={isDiarised}
              value={isDiarised}
              onChange={() => setDiarised(!isDiarised)}
            />
          </div>
          {file?.name && (
            <div>
              <button onClick={handleFileUpload} className="btn upload">
                Upload
              </button>
            </div>
          )}
        </div>
      )}
      {uploadStatus && <p>{uploadStatus}</p>}
      {errorPageData}
    </div>
  );
};

export default UploadFile;
